// deps
import React, { memo, useCallback } from "react";
import { useEffectOnce } from "@swiggy-private/core-ui";

// styles
import { TransactionBtnV2, TransactionBtnWrapper } from "./styles";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// constants
import { FOOTER_TEXTS } from "@dineout-payment-success-ui/constants/Footer";

// test-ids
import { PAYMENT_SUCCESS_FOOTER } from "@swiggy-private/payment-test-ids";

// types
import { ITransactionCompleteBtn } from "@dineout-payment-success-ui/interfaces";

const TransactionCompleteBtn: React.FC<ITransactionCompleteBtn> = ({
    customDoneCtaText,
    doneClickHandler,
    isFullWidthCta = false,
    doneClickEventHandler,
    doneImpressionEventHandler,
    isTransactionBtnV2 = false,
}) => {
    const handleDoneClick = useCallback(() => {
        doneClickEventHandler?.();
        doneClickHandler();
    }, [doneClickEventHandler, doneClickHandler]);

    useEffectOnce(() => {
        doneImpressionEventHandler?.();
    });

    const label = customDoneCtaText || FOOTER_TEXTS.PAYMENT_DONE;

    if (isTransactionBtnV2) {
        return (
            <TransactionBtnV2
                buttonSize="medium"
                color="text_Button_Secondary"
                removePadding
                onClick={handleDoneClick}
                data-testid={PAYMENT_SUCCESS_FOOTER.DONE_BTN}
            >
                {label}
            </TransactionBtnV2>
        );
    }

    return (
        <TransactionBtnWrapper
            onClick={handleDoneClick}
            data-testid={PAYMENT_SUCCESS_FOOTER.DONE_BTN}
            isFullWidthCta={isFullWidthCta}
        >
            <Text variant="V2.body1.neutral.bold" color="text_Button_Primary">
                {label}
            </Text>
        </TransactionBtnWrapper>
    );
};

export default memo(TransactionCompleteBtn);
